import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { useLanguage } from '../lib/LanguageContext';
import { Cookie, X } from 'lucide-react';

const KEY = 'bfi_cookie_consent_v1';

export default function CookieBanner() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [prefs, setPrefs] = useState({ necessaires: true, analytiques: true, marketing: false });

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) setTimeout(() => setVisible(true), 800);
  }, []);

  const accept = (all = true) => {
    const value = all ? { necessaires: true, analytiques: true, marketing: true, when: new Date().toISOString() }
                      : { ...prefs, when: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(value));
    setVisible(false);
  };
  const refuse = () => {
    localStorage.setItem(KEY, JSON.stringify({ necessaires: true, analytiques: false, marketing: false, when: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] p-4 md:p-6 animate-fadeIn">
      <div className="max-w-5xl mx-auto bg-white border border-slate-200 rounded-2xl shadow-2xl overflow-hidden">
        {!showSettings ? (
          <div className="p-5 md:p-6 flex flex-col md:flex-row gap-4 items-start md:items-center">
            <div className="w-12 h-12 rounded-xl bg-blue-50 text-blue-700 flex items-center justify-center shrink-0">
              <Cookie className="w-6 h-6"/>
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-900">{t('cookie.prefsTitle')}</div>
              <p className="text-sm text-slate-600 mt-1">
                {t('cookie.message')} <a href="#" className="text-blue-700 underline">{t('cookie.learnMore')}</a>.
              </p>
            </div>
            <div className="flex flex-wrap gap-2 shrink-0">
              <Button variant="ghost" size="sm" onClick={refuse} data-testid="btn-cookies-refuse">{t('cookie.refuse')}</Button>
              <Button variant="outline" size="sm" onClick={() => setShowSettings(true)} data-testid="btn-cookies-settings">{t('cookie.customize')}</Button>
              <Button size="sm" className="bg-blue-700 hover:bg-blue-800" onClick={() => accept(true)} data-testid="btn-cookies-accept">{t('cookie.acceptAll')}</Button>
            </div>
          </div>
        ) : (
          <div className="p-5 md:p-6">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-semibold text-slate-900">{t('cookie.customizeTitle')}</div>
                <p className="text-sm text-slate-500 mt-1">{t('cookie.customizeDesc')}</p>
              </div>
              <button onClick={() => setShowSettings(false)} className="text-slate-400 hover:text-slate-700"><X className="w-5 h-5"/></button>
            </div>
            <div className="mt-4 space-y-3">
              <div className="flex items-start justify-between p-3 rounded-lg bg-slate-50">
                <div>
                  <div className="font-medium text-sm">{t('cookie.necTitle')}</div>
                  <div className="text-xs text-slate-500">{t('cookie.necDesc')}</div>
                </div>
                <input type="checkbox" checked disabled className="mt-1 accent-blue-700"/>
              </div>
              <div className="flex items-start justify-between p-3 rounded-lg border border-slate-200">
                <div>
                  <div className="font-medium text-sm">{t('cookie.anaTitle')}</div>
                  <div className="text-xs text-slate-500">{t('cookie.anaDesc')}</div>
                </div>
                <input type="checkbox" checked={prefs.analytiques} onChange={(e) => setPrefs({ ...prefs, analytiques: e.target.checked })} className="mt-1 accent-blue-700"/>
              </div>
              <div className="flex items-start justify-between p-3 rounded-lg border border-slate-200">
                <div>
                  <div className="font-medium text-sm">{t('cookie.mktTitle')}</div>
                  <div className="text-xs text-slate-500">{t('cookie.mktDesc')}</div>
                </div>
                <input type="checkbox" checked={prefs.marketing} onChange={(e) => setPrefs({ ...prefs, marketing: e.target.checked })} className="mt-1 accent-blue-700"/>
              </div>
            </div>
            <div className="mt-5 flex flex-wrap justify-end gap-2">
              <Button variant="ghost" size="sm" onClick={refuse}>{t('cookie.refuseAll')}</Button>
              <Button size="sm" className="bg-blue-700 hover:bg-blue-800" onClick={() => accept(false)} data-testid="btn-cookies-save">{t('cookie.saveChoices')}</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
